import type { RefundSummaryShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { showValueOrHyphen } from 'Util/formatters'
import InfoIcon from '@mui/icons-material/Info'
import { Box } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import type { FC } from 'react'

const RefundInfo: FC<{
  refundSummary: RefundSummaryShape
}> = ({ refundSummary }) => {
  return (
    <Box>
      <Typography component="span" color="text.primary" fontSize={14} mr={1}>
        {showValueOrHyphen(refundSummary.status?.text)}
      </Typography>
      {refundSummary.note && (
        <Tooltip title={refundSummary.note}>
          <IconButton sx={{ padding: 0 }}>
            <InfoIcon color="primary" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export { RefundInfo }
